import { createFileRoute, Outlet } from '@tanstack/react-router'

import { ContentContainerBackoffice, useTranslate } from '@orus.eu/pharaoh'

import { BackofficeSectionTitle } from '../../../../components/atoms/backoffice-section-title.tsx'
import { ExclusionsPageTabbar } from '../../../../components/pages/backoffice/platform/platform-documentation/exclusions-page-tabbar.tsx'

export const Route = createFileRoute('/bo/documentation/exclusions')({
  component: ExclusionsPage,
})

function ExclusionsPage() {
  const translate = useTranslate()

  return (
    <ContentContainerBackoffice>
      <BackofficeSectionTitle>{translate('backoffice_exclusions_page_heading')}</BackofficeSectionTitle>
      <ExclusionsPageTabbar />
      <Outlet />
    </ContentContainerBackoffice>
  )
}
